  <ion-header>
    <ion-toolbar>
      @defer (when loaded()) {
        <ion-item lines="none" color="none">
          <ion-label>{{ venueDetailsService.venue()?.venueName }} ({{ venueDetailsService.venue().venueAbbreviation}})</ion-label>
        </ion-item>
      } @loading (minimum 0.6s) {
        <ion-spinner isOpen="true" name="dots"></ion-spinner>
      }
      <ion-buttons slot="start">
        <ion-back-button defaultHref="smart-venues"></ion-back-button>
      </ion-buttons>

      <ion-buttons slot="end">
        <ion-button size="default" (click)="isEditModalOpen = true">
          <ion-icon slot="icon-only" name="create-outline"></ion-icon>
        </ion-button>
      </ion-buttons>

    </ion-toolbar>
  </ion-header>

  <ion-content>
    @defer (when loaded()) {
      <ion-toolbar class="content-width toolbar-border" color="light">
        <ion-segment [scrollable]="true" #segment>
          <ion-segment-button value="courts" [routerLink]="['courts']" routerLinkActive="segment-button-checked">
            <ion-label>{{'Courts' | translate}}</ion-label>
          </ion-segment-button>
  
          <ion-segment-button value="integrations" [routerLink]="['integrations']" routerLinkActive="segment-button-checked" >
            <ion-label>{{'Integrations' | translate}}</ion-label>
          </ion-segment-button>

          <ion-segment-button value="video-boards" [routerLink]="['video-boards']" routerLinkActive="segment-button-checked" [routerLinkActiveOptions]="{exact: false}">
            <ion-label>{{'Video Boards' | translate}}</ion-label>
          </ion-segment-button>

          <ion-segment-button value="admins" [routerLink]="['admins']" routerLinkActive="segment-button-checked">
            <ion-label>{{'Admins' | translate}}</ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-toolbar>

      <!-- Video Boards Sub-toolbar -->
      @if (segment.value === 'video-boards') {
        <ion-toolbar class="content-width" color="light">
          <ion-segment [scrollable]="true" value="video-boards/my-scoreboards">
            <ion-segment-button value="video-boards/my-scoreboards" [routerLink]="['video-boards/my-scoreboards']" routerLinkActive="segment-button-checked">
              <ion-label>{{'My Scoreboards' | translate}}</ion-label>
            </ion-segment-button>

            <ion-segment-button value="video-boards/settings" [routerLink]="['video-boards/settings']" routerLinkActive="segment-button-checked">
              <ion-label>{{'Settings' | translate}}</ion-label>
            </ion-segment-button>
          </ion-segment>
        </ion-toolbar>
      }

      <router-outlet></router-outlet>

      <ion-button class="content-width ion-margin" color="danger" (click)="deleteVenue()" expand="block" fill="clear">
        {{'Delete Venue' | translate}}
      </ion-button>
      
      <ion-modal 
        [initialBreakpoint]="1" 
        [breakpoints]="[0, 1]" 
        [isOpen]="isEditModalOpen" 
        (ionModalDidDismiss)="isEditModalOpen = false">
        <ng-template>
          <div class="wrapper">
            <h1>{{'Edit Venue' | translate}}</h1>

            <ion-list>
              <form [formGroup]="editForm">
                <ion-item detail="false">
                  <ion-input type="text" label="{{'Venue name' | translate}}" labelPlacement="stacked" placeholder="{{'Enter venue name' | translate}}" formControlName="venueName"></ion-input>
                </ion-item>

                <ion-item detail="false">
                  <ion-input type="text" label="{{'Venue abbreviation' | translate}}" labelPlacement="stacked" placeholder="{{'Enter venue abbreviation' | translate}}" formControlName="venueAbbreviation"></ion-input>
                </ion-item>

                <ion-button (click)="edit()" expand="block" class="ion-margin">
                  {{'Submit' | translate}}
                </ion-button>
              </form>
            </ion-list>
          </div>
        </ng-template>
      </ion-modal>

    } @loading (minimum 0.6s) {
      <ion-loading isOpen="true" name="crescent"></ion-loading>
    }
  </ion-content>



